import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import renderViewsState from '../shared/render-views-state';

import Table from './components/table';
import CategorySelector from './components/category-selector';
import Popup from './components/popup-order';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

lessRequire('modules/bm-accounts/main.less');

const Main = renderViewsState(props => {
	const {intl} = props;

	return (
		<div className="container__with-columns container bm-container">
			<div className="column_left container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{intl('Бизнес Менеджер аккаунты от партнеров')}</h2>
				</div>
				<div className="container__content-description">
					{intl('Пользуйся качественными проверенными аккаунтами')}
				</div>
				<CategorySelector {...props}/>
				<Table {...props}/>
				<Popup {...props} isOpen={props.isOpenPopup}/>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		tableData: selectors.getTableData(state),
		categories: selectors.getCategories(state),
		selectedCategoryIds: selectors.getSelectedCategoryIds(state),
		popupAccountData: selectors.getPopupAccountData(state),
		popupType: selectors.getPopupType(state),
		isOpenPopup: selectors.getIsOpenPopup(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/main.js